import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Apollo, gql } from 'apollo-angular';
import { ToastService } from '../../shared/toast/toast.service';

const REQUEST_PASSWORD_RESET = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: false,
})
export class ForgotPasswordComponent {
  form: FormGroup;
  isSubmitting = false;
  isSent = false;
  submittedEmail = '';

  constructor(
    private fb: FormBuilder,
    private apollo: Apollo,
    private toast: ToastService,
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    if (this.form.invalid || this.isSubmitting) return;
    this.isSubmitting = true;
    const { email } = this.form.value;
    this.apollo
      .mutate({ mutation: REQUEST_PASSWORD_RESET, variables: { email } })
      .subscribe({
        next: () => {
          this.isSubmitting = false;
          this.isSent = true;
          this.submittedEmail = email;
        },
        error: (err) => {
          this.isSubmitting = false;
          this.toast.error(err?.message || 'Could not start password reset.');
        },
      });
  }
}
